import {
  ACCOUNTS_RECEIVABLE_URL,
  APP_URL,
  BUDGET_URL,
  PROCUREMENT_URL,
  QUOTE_URL,
  SPEND_URL,
  STORAGE_URL,
  TAX_URL,
  PAY_URL,
  GUIDES_URL,
  WRIGHT_URL,
} from './app/consts/env';
import { ROUTES } from '@core-ui/consts';

const windowProps = {
  appUrl: APP_URL,
  spendUrl: SPEND_URL,
  quoteUrl: QUOTE_URL,
  budgetUrl: BUDGET_URL,
  taxUrl: TAX_URL,
  procurementUrl: PROCUREMENT_URL,
  accountsReceivableUrl: ACCOUNTS_RECEIVABLE_URL,
  storageUrl: STORAGE_URL,
  payUrl: PAY_URL,
  guidesUrl: GUIDES_URL,
  wrightUrl: WRIGHT_URL,
};

const version = new Date().getTime();
window.getVersion = () => version;

Object.entries(windowProps).forEach(([key, value]) => {
  Object.defineProperty(window, key, {
    value,
    writable: false,
  });
});

// the OIDC silent-renew iframe lands on this route and must not boot the shell
if (window.location.pathname.startsWith(ROUTES.SILENT_LOGIN)) {
  void import('./silent-renew').then(({ handleSilentRenewCallback }) => handleSilentRenewCallback());
} else {
  import('./bootstrap');
}
